


























































import { Component } from 'vue-property-decorator';
import * as api from '@/api';
import { State } from 'vuex-class';
import { PaginationMixin } from '@/utils/mixin';
import AddRg from './detail/components/add-rg.vue';
/**
 * rg列表
 *
 * @author xiaokunyu
 * @date 01/11/2019
 */
@Component({
    components: {
        AddRg
    }
})
export default class RgList extends PaginationMixin {
    @State(state => state.cti.env)
    env: string;

    rgList: CommonTypes.RgItem[] = [];
    addRgVisible: Boolean = false;
    tableLoading: Boolean = true;
    firstLoading: Boolean = true;
    $mtd: any;
    async created() {
        await this.getRgList();
        this.firstLoading = false;
    }
    async getRgList() {
        this.tableLoading = true;
        try {
            const res = await api.rgApi.getMyRg({
                cn: this.currentPage,
                sn: this.limit
            });
            const { code, data } = res;
            if (code === 200) {
                this.rgList = data.items;
                this.total = data.tn;
                if (this.total > 0 && !data.items.length) {
                    this.currentPage -= 1;
                    if (this.currentPage <= 0) {
                        this.currentPage = 1;
                    }
                    this.getRgList();
                }
            }
        } catch (e) {
            this.rgList = [];
            console.log(e);
        }
        this.tableLoading = false;
    }
    handleChange(current: number, size: number) {
        this.limit = size;
        this.currentPage = current;
        this.getRgList();
    }
    // 进入rg详情
    handleDetail(id: number) {
        this.$router
            .push({
                name: 'rg_catalog',
                query: {
                    rgId: `${id}`
                }
            })
            .catch(e => e);
    }
    // 移除rg
    handleDeleteRg(id: number) {
        const _this = this;
        this.$mtd
            .confirm({
                title: '你是否确认移除该 RG？',
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: '移除',
                okButtonProps: {
                    type: 'danger'
                },
                onOk: async () => {
                    try {
                        await api.rgApi.deleteRg(id);
                        this.$mtd.message({
                            message: '移除成功',
                            type: 'success'
                        });
                        await _this.getRgList();
                    } catch (e) {
                        console.log(e);
                    }
                }
            })
            .catch(e => e);
    }
    handleAddRg() {
        this.addRgVisible = true;
    }
    get aboutUrl() {
        const url = this.env === 'prod' ? 'https://km.sankuai.com/collabpage/2734292781' : 'https://km.sankuai.com/collabpage/2734292781';
        return url;
    }
}
